/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable consistent-return */
/* eslint-disable jsx-quotes */

import React, {
  useState,
  useContext,
  useEffect,
  useRef,
} from 'react';
import {
  Box, IconButton, Stack, Typography,
} from '@mui/material';
import ReactDOM from 'react-dom';
import ReactPlayer from 'react-player';
import Iconify from '../Iconify';
import { protectedFetch } from '../../utils/network';
import GenericAlertDialogContext from '../../contexts/GenericAlertDialogContext';

export default function Video({
  type,
  apiKey,
  supportId,
  playOnStart,
}) {
  const [blob, setBlob] = useState(new Blob());
  const [dataURL, setDataURL] = useState(new Blob());
  const [error, setError] = useState(false);
  const { handleSetGenericAlertDialogFromGenericResponse } = useContext(GenericAlertDialogContext);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const url = (
      `/api/support_original_data/${apiKey}/${supportId}`
    );
    const supportFileFetch = protectedFetch(url, {
      method: 'get',
      headers: {
        accept: 'application/json',
      },
    });
    supportFileFetch.then((supportFile) => {
      if (supportFile !== null) {
        if (!supportFile.success) {
          handleSetGenericAlertDialogFromGenericResponse(supportFile, 'supportFileFetch');
          return;
        }
        const byteCharacters = atob(supportFile.data);
        const byteArrays = [];
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArrays.push(byteCharacters.charCodeAt(i));
        }
        const byteArray = new Uint8Array(byteArrays);

        const tempBlob = new Blob([byteArray], { type: 'octet/stream' });
        setBlob(tempBlob);
        setDataURL(window.URL.createObjectURL(tempBlob));
      }
    });
  }, []);

  const saveData = (filename) => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  if (error) {
    return (
      <Box>
        <Typography variant="h6" sx={{ mt: 3, color: '#000000' }}>
          {' '}
          Cannot Play
          {' '}
          {(type === 'processed_audio_data') ? 'Processed' : 'Original'}
          {' '}
          File
          {' '}
        </Typography>
      </Box>
    );
  }
  return (
    <Stack>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h6" sx={{ mt: 2, color: '#000000' }}>
          {
            (type === 'processed_audio_data')
              ? 'Processed' : 'Original'
          }
        </Typography>
        <IconButton
          variant="contained"
          onClick={() => { saveData(`${type}${apiKey}${supportId}.wav`); }}
        >
          <Iconify
            icon="carbon:download"
            sx={{ color: '#000000', height: 20, width: 20 }}
          />
        </IconButton>

      </Stack>

      <Box
        role="button"
        tabIndex="0"
        onClick={() => {
          setIsPlaying(!isPlaying);
       }}
      >
        <ReactPlayer
          playing={isPlaying}
          width='100%'
          height='100%'
          url={dataURL}
          controls
          onReady={() => {
            setIsPlaying(true);
          }}
        />
      </Box>
    </Stack>
  );
}
